import { useAuthSlice } from '@restore/auth/auth.slice';
import { getIsSponsor } from '@utils/roles';

/** Reads the authenticated user from the auth slice and checks the Sponsor role. */
export const useIsSponsor = (): boolean => {
  const auth = useAuthSlice();
  return getIsSponsor(auth.data);
};
